import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { SharedService } from 'src/app/services/shared.service';
import { Location } from '@angular/common';
import { BranchHttpService } from 'src/app/http/branch-http.service';
import { MediaLibraryHttpService } from 'src/app/http/media-library-http.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EventsService } from 'src/app/services/events.service';
import { MediaModalComponent } from 'src/app/shared/modals/media-modal/media-modal.component';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ConfirmModalComponent } from 'src/app/shared/modals/confirm-modal/confirm-modal.component';

@UntilDestroy()
@Component({
    selector: 'app-branch-edit',
    templateUrl: './branch-edit.component.html',
    styles: [],
})
export class BranchEditComponent implements OnInit, OnDestroy {
    constructor(
        private fb: FormBuilder,
        private branchHttpService: BranchHttpService,
        private sharedService: SharedService,
        private router: Router,
        public location: Location,
        private mediaLibraryHttpService: MediaLibraryHttpService,
        private modalService: NgbModal,
        private eventsService: EventsService,
        private activatedRoute: ActivatedRoute
    ) {}

    editBranchForm = this.fb.group(
        {
            branchId: [null],
            branchName: [null, Validators.required],
            address: [null, Validators.required],
            phone: [null, Validators.required],
            mapLocation: [null],
            assetId: [null],
            isPublished: [false],
        },
        { updateOn: 'submit' }
    );

    branch: any;

    selectAsset: any;

    formBusy: boolean;

    ngOnInit(): void {
        this.routeData();
        this.eventsSub();
    }

    eventsSub() {
        this.eventsService.trigger.pipe(untilDestroyed(this)).subscribe((data) => {
            if (data.name === 'selectedAsset') {
                const selected = data.value.slice(-1).pop();
                if (selected) {
                    this.selectAsset = selected;
                    this.editBranchForm.controls['assetId'].setValue(selected.assetId);
                }
            }
        });
    }

    routeData() {
        this.activatedRoute.data.subscribe((data) => {
            this.branch = data.data;
            this.patchForm(data.data);
        });
    }

    patchForm(item: any) {
        this.editBranchForm.patchValue(item);
        if (item.asset) {
            this.selectAsset = item.asset;
        }
    }

    onSubmit() {
        this.editBranchForm.markAsTouched();

        if (this.editBranchForm.valid) {
            this.formBusy = true;
            this.branchHttpService.editBranch(this.editBranchForm.value).subscribe(
                (result) => {
                    this.router.navigateByUrl('branch-list', {
                        state: { hasState: true, type: 'success', message: 'Branch Edited successfully' },
                    });
                },
                (error) => {
                    this.formBusy = false;
                    this.editBranchForm.setErrors({ exists: true });
                }
            );
        }
    }

    openMedia() {
        this.mediaLibraryHttpService.getAllFolders().subscribe((folders) => {
            let media = this.modalService.open(MediaModalComponent, { size: 'xl', windowClass: 'media-library' });
            media.componentInstance.folders = folders;
        });
    }

    clearImages() {
        this.selectAsset = null;
        this.editBranchForm.controls['assetId'].setValue(null);
    }

    confirmDelete(item: any) {
        let confirm = this.modalService.open(ConfirmModalComponent);
        confirm.componentInstance.headerLabel = 'Delete';
        confirm.componentInstance.messageLabel = 'Are you sure you want to delete this content item?';
        confirm.result.then(
            (result) => {
                if (result === 'ok') {
                    this.delete(item);
                }
            },
            () => {}
        );
    }

    delete(item: any) {
        this.branchHttpService.deleteBranch(item.branchId).subscribe(() => {
            this.router.navigateByUrl('branch-list', {
                state: { hasState: true, type: 'success', message: 'Branch Deleted successfully' },
            });
        });
    }

    ngOnDestroy(): void {
        this.eventsService.trigger.next({ name: null, value: null });
    }
}
